import React, { useMemo } from 'react';
import classNames from 'classnames';
import { fontList } from '@mnz/builder';
import { FontSetting, useEditor } from '@mnz/builder';
import Dialog, { DialogProps } from '../../../../components/dialog/Dialog';

const convertFontName = (name: string) => name.split(/(?=[A-Z][a-z])/).join(' ');

const fontOptions = Object.keys(fontList).map((key) => ({
    value: key,
    label: convertFontName(key),
}));
interface ChooseFontModalProps extends DialogProps {
    type: 'primary' | 'secondary';
}
const ChooseFontModal: React.FC<ChooseFontModalProps> = ({ type, ...props }) => {
    const {
        designSettings,
        actions: { setFonts },
    } = useEditor((_, query) => ({
        designSettings: query.getDesignSettings(),
    }));

    const secondaryFonts = [
        'Arvo',
        'Barlow',
        'CourierPrime',
        'CrimsonPro',
        'DMSans',
        'Lora',
        'LibreBaskerville',
        'Inter',
        'Poppins',
        'Quicksand',
        'RobotoSlab',
        'RubikMonoOne',
        'Literata',
        'Podkova',
        'ClashGrotesk',
    ];

    const currentSetting = useMemo(() => designSettings?.fonts[type] || {}, [designSettings, type]);

    const handleSelectFont = (font: Partial<FontSetting>) => {
        setFonts(type, { ...currentSetting, ...font });
    };

    const currentFont = useMemo(() => {
        if (type === 'primary') {
            return designSettings?.fonts?.primary.fontFamily;
        }
        if (type === 'secondary') {
            return designSettings?.fonts?.secondary.fontFamily;
        }
    }, [type, designSettings?.fonts]);

    const fontList = useMemo(() => {
        if (type === 'primary') {
            return fontOptions;
        }
        if (type === 'secondary') {
            return fontOptions.filter((font) => {
                return secondaryFonts.indexOf(font.value) > -1;
            });
        }
    }, [type]);

    return (
        <Dialog {...props}>
            <div className="mt-20 pl-30 overflow-hidden">
                <div className="overflow-y-auto mr-30 max-h-230">
                    {fontList &&
                        fontList.map((font, idx) => (
                            <div
                                key={idx}
                                className={classNames({
                                    'px-15 pt-10 pb-15 border rounded-5': true,
                                    'border-white': currentFont !== font.value,
                                    'border-teal bg-started': designSettings && currentFont === font.value,
                                })}
                                onClick={() => handleSelectFont({ fontFamily: font.value })}
                            >
                                <div className="text-18" style={{ fontFamily: font.value }}>
                                    The quick brown fox eats
                                </div>
                                <p className="text-12 leading-13">{font.label}</p>
                            </div>
                        ))}
                </div>
            </div>
        </Dialog>
    );
};

export default ChooseFontModal;
